// This file exports toolbar configurations without importing CKEditor
// This allows importing toolbar configs without loading the entire CKEditor bundle

// Plugin UI IDs are hardcoded to avoid importing CKEditor.
// These must match the values returned by each Plugin.uiId:
//   TogglePlainText.uiId  → plugins/toggleplaintext/toggleplaintext.js
//   Autoplaceholder.uiId  → plugins/autoplaceholder/autoplaceholder.js
//   Unformat.uiId         → plugins/unformat/unformat.js
//   Clear.uiId            → plugins/clear/clear.js
const PLUGIN_UI_IDS = {
    togglePlainText: 'toggleplaintext',
    autoplaceholder: 'autoplaceholder',
    unformat: 'unformat',
    clear: 'clear'
};

export const toolbarSeparator = '|';

const toolbarBase = ['bold', 'italic', PLUGIN_UI_IDS.unformat];

const toolbarBaseAutomation = [
    ...toolbarBase,
    toolbarSeparator,
    PLUGIN_UI_IDS.autoplaceholder
];

const toolbarBasicStyle = [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    PLUGIN_UI_IDS.unformat,
    toolbarSeparator,
    'numberedList',
    'bulletedList',
    'alignment:left',
    'alignment:right',
    'alignment:center',
    'alignment:justify'
];

const automationStyleEnding = [
    toolbarSeparator,
    PLUGIN_UI_IDS.clear,
    PLUGIN_UI_IDS.togglePlainText
];

export const toolbars = {
    basicStyle: toolbarBasicStyle,
    automationStyle: [
        ...toolbarBaseAutomation,
        // 'sourceEditing',
        ...automationStyleEnding
    ],
    automationStyleWithoutPlaceholder: [
        ...toolbarBase,
        ...automationStyleEnding
    ],
    basicAndSourceEditStyle: [
        ...toolbarBasicStyle,
        toolbarSeparator,
        // 'sourceEditing',
        'link'
    ]
};
